import { fontFamilyConst } from '@klarna/designtokens';
import { platformSelect } from '@bubble-ui/util-platform';
export var defaultFontFamilies = platformSelect({
  web: {
    'font/klarna/text/regular': fontFamilyConst({
      fontFamily: 'Klarna Text',
      fontWeight: '400'
    }),
    'font/klarna/text/medium': fontFamilyConst({
      fontFamily: 'Klarna Text',
      fontWeight: '500'
    }),
    'font/klarna/text/bold': fontFamilyConst({
      fontFamily: 'Klarna Text',
      fontWeight: '700'
    }),
    'font/klarna/title/bold': fontFamilyConst({
      fontFamily: 'Klarna Title',
      fontWeight: '700'
    })
  },
  ios: {
    'font/klarna/text/regular': fontFamilyConst({
      fontFamily: 'Klarna Text',
      fontWeight: '400'
    }),
    'font/klarna/text/medium': fontFamilyConst({
      fontFamily: 'Klarna Text',
      fontWeight: '500'
    }),
    'font/klarna/text/bold': fontFamilyConst({
      fontFamily: 'Klarna Text',
      fontWeight: '700'
    }),
    'font/klarna/title/bold': fontFamilyConst({
      fontFamily: 'Klarna Title',
      fontWeight: '700'
    })
  },
  android: {
    'font/klarna/text/regular': fontFamilyConst({
      fontFamily: 'KlarnaText-Regular',
      fontWeight: '400'
    }),
    'font/klarna/text/medium': fontFamilyConst({
      fontFamily: 'KlarnaText-Medium',
      fontWeight: '500'
    }),
    // When we provide fontWeight '500' for 'KlarnaText-Bold' and 'KlarnaTitle-Bold' fonts,
    // it will be ignored by Android and the correct fontWeight '700' will be used.
    'font/klarna/text/bold': fontFamilyConst({
      fontFamily: 'KlarnaText-Bold',
      fontWeight: '500'
    }),
    'font/klarna/title/bold': fontFamilyConst({
      fontFamily: 'KlarnaTitle-Bold',
      fontWeight: '500'
    })
  }
});
//# sourceMappingURL=index.js.map